import {NavLink} from 'react-router-dom'; 
import { DiReact } from "react-icons/di";
function Header() {
    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container">
            <a  href="/">
                <DiReact size='5em'/>
            </a>
          
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>


              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                    <li className="nav-item">
                      <NavLink exact className="nav-link"   to="/" >Home</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink  className="nav-link"  to="/note">Note</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link"   to="/create">Create</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link"   to="/about">About</NavLink>
                    </li>
                  </ul>
              </div>
          </div>
        </nav>
      
      </div>
    );
  }
  
  export default Header;